package com.rainbowclubs.rainbow.data.requests

import com.rainbowclubs.rainbow.data.models.MembershipDataItem
import kotlinx.serialization.Serializable

@Serializable
data class UpdateClubRequest(
    val name: String,
    val description: String,
    val membershipData: List<MembershipDataItem>,
)
